import { EventEmitter, Injectable } from "@angular/core";
import { take } from "rxjs/operators";
import { AbWebview } from "../../../../../app/shared/enums/ab-webview.enum";
import { CommunicatorNativeRemoteConfig } from "./communicator-native-remote-config";

declare const GrowthInterface;

declare global {
  interface Window {
    growthInfoResponse: (data: any) => any;
    webkit: any;
  }
}

@Injectable({ providedIn: "root" })
export class CommunicatorNativeRemoteConfigService implements CommunicatorNativeRemoteConfig {
  private EmitChange = new EventEmitter<{ data }>();
  private reg: RegExp = new RegExp("(error|Error|erro|Erro)|(400|500|404|406)");

  constructor() {
    window.growthInfoResponse = (data: string) => this.EmitChange.emit({ data });
  }

  getRemoteConfigCommunicator<T>(key: string = AbWebview.ABWEBVIEW_GROWTHCSI_SUCESSO_CADASTRO_DE_CORRETORA): Promise<T> {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.RemoteConfig
    ) {
      this.communicationIOS(key);
    } else {
      this.communicationAndroid(key);
    }


    return new Promise<T>((resolve, reject) => {

      this.EmitChange.pipe(take(1)).subscribe((value) => {

        localStorage.setItem(`remote_config_data`, JSON.stringify(value));
        if (value.data) {
          if (this.reg.test(value.data)) {
            reject(value.data);
          }
        }
        resolve(value as T);
      });
    });
  }

  private communicationIOS(key: string) {
    window.webkit.messageHandlers.remoteConfig.postMessage(key);
  }

  private communicationAndroid(key: string) {
    try {
      const keyValue = JSON.stringify({ key });
      GrowthInterface.growthGetRemoteString(keyValue);

    } catch (error) {
      console.log('ERROR: ', error);
    }
  }
}
